import { render, staticRenderFns } from "./GisIndicatorComparison.vue?vue&type=template&id=40620d80&scoped=true"
import script from "./GisIndicatorComparison.vue?vue&type=script&lang=js"
export * from "./GisIndicatorComparison.vue?vue&type=script&lang=js"
import style0 from "./GisIndicatorComparison.vue?vue&type=style&index=0&id=40620d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40620d80",
  null
  
)

export default component.exports